import { useEffect, JSX, useRef } from 'react';

interface IClickProps {
  children: JSX.Element | JSX.Element[];
  className?: string;
  onClickOutside: any;
}

export default function ClickOutside(props: IClickProps) {
  const wrapperRef = useRef(null as null | HTMLDivElement);

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        props.onClickOutside(event);
      }
    };

    document.addEventListener('mouseup', handleClickOutside);
    return () => {
      document.removeEventListener('mouseup', handleClickOutside);
    };
  });

  return (
    <div className={props.className} ref={wrapperRef}>
      <div>{props.children}</div>
    </div>
  );
}
